export default __webpack_public_path__ + "static/media/sazmani.9db8da2c.svg";